import { httpBatchLink } from '@trpc/client';
import { createTRPCReact } from '@trpc/react-query';
import type { AppRouter } from '../../../src/admin/routers';

/**
 * Typed React Query hooks for the admin tRPC API. Components access
 * procedures via `trpc.<router>.<proc>.useQuery()` / `.useMutation()`.
 */
export const trpc = createTRPCReact<AppRouter>();

/**
 * Build a tRPC client bound to the current ID token. Re-created whenever
 * the token changes so the `Authorization` header reflects the latest
 * value. Pass `null` for unauthenticated calls.
 */
export function makeTrpcClient(idToken: string | null) {
  return trpc.createClient({
    links: [
      httpBatchLink({
        url: '/api/trpc',
        headers() {
          return idToken ? { Authorization: `Bearer ${idToken}` } : {};
        },
      }),
    ],
  });
}
